import React from "react";
import PropTypes from "prop-types";

import Button from "components/CustomButtons/Button.js";
import AddIcon from '@mui/icons-material/Add';
import Tooltip from "@mui/material/Tooltip";
import Zoom from "@mui/material/Zoom";

export default function AddDashboard(props) {
  const {  handleNewDashboard, ...other } = props;

  return (
    <Tooltip
      TransitionComponent={Zoom}
      arrow
      interactive
      placement="top"
      title="Nouveau dashboard"
    >
     { <Button
        style={{
          color: "#FFFFFF",
          backgroundColor: "#91C73C",
          fontWeight: "normal",
          fontWeight: "bold",
          height: "40px",
          fontSize: "0.75rem",
          padding: "5px 15px",
          marginLeft: "-10px",
          marginRight: "10px",
          marginBottom: "13px",
          fontFamily: '"Source Sans Pro",sans-serif',

        }}
        onClick={() => {
          handleNewDashboard();
        }}
      >
        <AddIcon fontSize="small" style={{
          marginRight: "6px"
        }}/>
        Nouveau Dashboard
      </Button>  }
    </Tooltip>
  );
}
